import React, { useEffect } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useLocation } from "react-router-dom";
import { useFormTo } from "../../hooks/useFormTo";
import { usePublicConfig } from "../../hooks/usePublicConfig";
import { MIGRATIONS_PATH } from "../../router/path/migrations";

function Fallback({ resetErrorBoundary, error }) {
  const location = useLocation();
  const { prefix } = useFormTo();
  const { env } = usePublicConfig();

  useEffect(() => {
    const targetPath = `/${prefix && `${prefix}/`}${
      MIGRATIONS_PATH.MY_MIGRATIONS_LIST
    }`;

    if (env?.hostEnv === "production" && location.pathname !== targetPath) {
      window.location.href = targetPath;
      resetErrorBoundary();
    }
  }, [resetErrorBoundary, env?.hostEnv, prefix, location.pathname]);

  if (env?.hostEnv !== "production") {
    return <pre style={{ color: "red" }}>{error.message}</pre>;
  }

  return null;
}

const ErrorProvider = ({ children }) => (
  <ErrorBoundary FallbackComponent={Fallback}>{children}</ErrorBoundary>
);

export default ErrorProvider;
